import * as idEndpoints from './id';
import * as meEndpoints from './me';

export const users = {
  id: {
    ...idEndpoints,
  },
  me: meEndpoints,
};
